export default "__VITE_ASSET__BY3TgUP7__"